import { initClient, initClientNavigation } from 'rwsdk/client';

initClientNavigation();
initClient();
